export namespace Statistics {
  export const maxPlayerAbility = 20;
  export const maxStats = 6;
}
